import { render, staticRenderFns } from "./DedicationInfo.vue?vue&type=template&id=2a027584&scoped=true"
import script from "./DedicationInfo.vue?vue&type=script&lang=js"
export * from "./DedicationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a027584",
  null
  
)

export default component.exports